interface IconCarFanFilledProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconCarFanFilled
 */
const IconCarFanFilled = ({ size = 48, color = '#31B9EF', className }: IconCarFanFilledProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9676)">
      <path
        d="M25.2261 4.13593L35.0501 7.96393C35.9394 8.31012 36.7212 8.88582 37.3157 9.63241C37.9101 10.379 38.2961 11.2698 38.4344 12.2141C38.5726 13.1584 38.458 14.1225 38.1025 15.0082C37.7469 15.8938 37.1629 16.6694 36.4101 17.2559L30.3201 21.9979L42.5001 21.9999C42.8254 21.9999 43.1459 22.0792 43.4336 22.231C43.7214 22.3828 43.9678 22.6025 44.1514 22.871C44.3351 23.1396 44.4504 23.4489 44.4875 23.7722C44.5245 24.0954 44.4822 24.4228 44.3641 24.7259L40.5361 34.5499C40.1899 35.4393 39.6142 36.221 38.8676 36.8155C38.121 37.41 37.2302 37.796 36.2859 37.9342C35.3416 38.0724 34.3775 37.9579 33.4918 37.6023C32.6062 37.2467 31.8306 36.6628 31.2441 35.9099L26.5001 29.8159V41.9999C26.5001 42.3253 26.4208 42.6457 26.269 42.9335C26.1172 43.2213 25.8975 43.4677 25.6289 43.6513C25.3604 43.8349 25.0511 43.9503 24.7278 43.9873C24.4046 44.0244 24.0772 43.982 23.7741 43.8639L13.9501 40.0359C13.0607 39.6898 12.279 39.114 11.6845 38.3675C11.09 37.6209 10.704 36.73 10.5658 35.7857C10.4275 34.8414 10.5421 33.8774 10.8977 32.9917C11.2532 32.1061 11.8372 31.3305 12.5901 30.7439L18.6801 25.9999H6.50006C6.17471 26 5.85425 25.9207 5.56649 25.7689C5.27872 25.6171 5.03233 25.3974 4.84869 25.1288C4.66505 24.8603 4.5497 24.5509 4.51265 24.2277C4.47559 23.9045 4.51795 23.5771 4.63606 23.2739L8.46406 13.4499C8.81024 12.5606 9.38594 11.7788 10.1325 11.1843C10.8791 10.5899 11.7699 10.2038 12.7142 10.0656C13.6586 9.92742 14.6226 10.0419 15.5083 10.3975C16.3939 10.7531 17.1695 11.3371 17.7561 12.0899L22.4981 18.1779L22.5001 5.99993C22.5 5.67459 22.5793 5.35413 22.7311 5.06637C22.8829 4.7786 23.1026 4.53221 23.3712 4.34857C23.6397 4.16493 23.949 4.04958 24.2723 4.01253C24.5955 3.97547 24.9229 4.01783 25.2261 4.13593Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9676">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconCarFanFilled;
